import { render, staticRenderFns } from "./WorkAreaWidget.vue?vue&type=template&id=a9092b6c&"
import script from "./WorkAreaWidget.vue?vue&type=script&lang=js&"
export * from "./WorkAreaWidget.vue?vue&type=script&lang=js&"
import style0 from "./WorkAreaWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports